import {connect} from 'react-redux';
import CreateGameComponent from "./CreateGameComponent";
import {openSearchbar, showLoadingIndicator, clearSearch, disableStartingGame, activateSearch, activateCourseTab,
    activatePlayersTab, selectPlayer, selectCourse, hideLoadingIndicator, createNewUserFormShowForm,
    createNewUserFormHideForm}
    from "../actions";
import {search, createGame, createUser, fetchCourses} from '../thunkActions';


const mapStateToProps = state => ({
    courses: state.courses,
    activeTab: state.activeTab,
    disableStartingGame: state.disableStartingGame,
    players: state.players,
    form: state.form,
    search: state.search,
    loadingIndicator: state.loadingIndicator,
    createNewUserForm: state.createNewUserForm,
});

const mapDispatchToProps = dispatch => ({
    selectCourse: (courseId) => {
        dispatch(selectCourse(courseId));
        dispatch(activatePlayersTab());
        dispatch(clearSearch());
    },
    selectPlayer: (player) => {
        dispatch(selectPlayer(player));
        dispatch(clearSearch());
    },
    goBack: () => {
        dispatch(activateCourseTab());
        dispatch(clearSearch());
    },
    startGame: (form) => {
        dispatch(disableStartingGame());
        dispatch(createGame(form));
    },
    onOpenSearch: () => {
        dispatch(createNewUserFormHideForm());
        dispatch(openSearchbar());
    },
    onSearch: (activeTab, query) => {
        // If the query is an empty string, then we don't fetch anything from the server. That's why we have to
        // manually hide the loading indicator in that case. Otherwise the loading indicator is hidden after
        // getting the response from the server.
        if (query === '') {
            dispatch(hideLoadingIndicator());
        }
        dispatch(activateSearch(activeTab, query));

        let getLocation = false;
        setTimeout(() => {
            if (!getLocation) {
                dispatch(fetchCourses({}));
            }
        }, 6000);

        navigator.geolocation.getCurrentPosition((location) => {
            getLocation = true;
            dispatch(search(activeTab, query, location.coords.latitude, location.coords.longitude));
        }, () => {
            getLocation = true;
            dispatch(search(activeTab, query));
        }, {maximumAge: 300000});
    },
    onClearSearch: () => {
        dispatch(clearSearch());
    },
    showLoadingIndicator: () => {
        dispatch(showLoadingIndicator());
    },
    createUser: (email) => {
        dispatch(createUser(email));
    },
    onAddNewUserButtonClick: () => {
        dispatch(createNewUserFormShowForm());
    },
    onCreateNewUserFormHideForm: () => {
        dispatch(createNewUserFormHideForm());
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CreateGameComponent);




// WEBPACK FOOTER //
// ./src/apps/create_game/components/CreateGameConnector.js